import { instance } from "libs/api";

import { ApiRoutesDeliveryCompanies } from "../../constants";
import { DeliveryCompanyListItem } from "../../deliveryCompanies.types";

export const requestGetDeliveryCompany = async (
  companyId: string
): Promise<DeliveryCompanyListItem> => {
  return await instance.get(
    `${ApiRoutesDeliveryCompanies.CompaniesOne}/${companyId}`
  );
};
